import { CircularProgress, ListItemIcon, ListItemText, Menu, MenuItem, Tooltip } from '@mui/material';

import type { Proposal } from 'api/projectVersioning/types';
import { ConditionalWrapper } from 'components/data-display/ConditionalWrapper';
import { IMPORT_IN_PROGRESS_TOOLTIP } from 'state/imports/importsInProgress';

type ActiveProposalRowMenuProps = {
  anchorEl: HTMLElement | null;
  open: boolean;
  proposal: Proposal | null;
  onClose: () => void;
  navigateToProposal: (targetProposalId: string) => void;
  onDiscardProposal: () => void;
  disabled?: boolean;
  loading?: boolean;
};

export const ActiveProposalRowMenu: React.FC<ActiveProposalRowMenuProps> = ({
  anchorEl,
  open,
  proposal,
  onClose,
  navigateToProposal,
  onDiscardProposal,
  disabled = false,
  loading = false
}) => (
  <Menu
    open={open}
    anchorEl={anchorEl}
    onClose={onClose}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
    slotProps={{ paper: { sx: { minWidth: 160 } } }}
    data-testid='active-proposal-row-menu'
  >
    <MenuItem
      onClick={() => proposal && navigateToProposal(proposal.id)}
      disabled={!proposal}
      data-testid='active-proposal-row-menu-open'
    >
      <ListItemText>Open</ListItemText>
    </MenuItem>
    <ConditionalWrapper
      condition={disabled && !loading}
      wrapper={(children) => (
        <Tooltip title={IMPORT_IN_PROGRESS_TOOLTIP}>
          <span>{children}</span>
        </Tooltip>
      )}
    >
      <MenuItem
        onClick={onDiscardProposal}
        disabled={disabled || loading}
        data-testid='active-proposal-row-menu-discard'
      >
        {loading && (
          <ListItemIcon>
            <CircularProgress size={16} />
          </ListItemIcon>
        )}
        <ListItemText>Discard</ListItemText>
      </MenuItem>
    </ConditionalWrapper>
  </Menu>
);
